import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { COMPRASINGRESOGUIA_LISTA, COMPRASINGRESOGUIA_NUEVO, COMPRASINGRESOGUIA_EDITAR } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'
import EditarPage from './editar'

export default function ComprasIngresoGuiaPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${COMPRASINGRESOGUIA_LISTA}`} component={ListaPage} />
        <Route path={`/${COMPRASINGRESOGUIA_NUEVO}`} component={NuevoPage} />
        <Route path={`/${COMPRASINGRESOGUIA_EDITAR}/:idGuia`} component={EditarPage} />
      </Switch>
    </Suspense>
  )
}
